const ArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 7.4">
            <path fill="#27230b" d="M10.6 0 6 4.6 1.4 0 0 1.4l6 6 6-6L10.6 0z"/>
        </svg>
    );
};

export default ArrowDown;
